import { forwardRef } from 'react';

import { IconProps } from '.';

export const CloseIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M14.51 12.9198C14.6505 13.0605 14.7294 13.2511 14.7294 13.4498C14.7294 13.6486 14.6505 13.8392 14.51 13.9798L13.98 14.5098C13.8394 14.6503 13.6488 14.7292 13.45 14.7292C13.2513 14.7292 13.0606 14.6503 12.92 14.5098L10 11.5898L7.08002 14.5098C6.93939 14.6503 6.74877 14.7292 6.55002 14.7292C6.35127 14.7292 6.16064 14.6503 6.02002 14.5098L5.49002 13.9998C5.34957 13.8592 5.27068 13.6686 5.27068 13.4698C5.27068 13.2711 5.34957 13.0805 5.49002 12.9398L8.41002 9.99985L5.49002 7.07985C5.41743 7.00988 5.35969 6.92601 5.32026 6.83322C5.28082 6.74044 5.2605 6.64066 5.2605 6.53985C5.2605 6.43903 5.28082 6.33925 5.32026 6.24647C5.35969 6.15369 5.41743 6.06981 5.49002 5.99985L6.00002 5.48985C6.14064 5.3494 6.33127 5.27051 6.53002 5.27051C6.72877 5.27051 6.91939 5.3494 7.06002 5.48985L10 8.40985L12.92 5.48985C13.0606 5.3494 13.2513 5.27051 13.45 5.27051C13.6488 5.27051 13.8394 5.3494 13.98 5.48985L14.51 6.01985C14.6505 6.16047 14.7294 6.3511 14.7294 6.54985C14.7294 6.7486 14.6505 6.93922 14.51 7.07985L11.59 9.99985L14.51 12.9198Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default CloseIcon;
